<template>
    <div
            v-if="isMapDisplayed"
            class="property-search-footer mt-3 px-2"
    >
        <b-row>
            <template
                    v-for="(info, index) in footerData"
            >
                <b-col
                        v-if="info.asset"
                        :key="`footer-asset-${index}`"
                        cols="12"
                        md="2"
                        class="d-flex align-items-center justify-content-start logo-container"
                >
                    <b-img
                            :src="info.asset.url"
                            class="w-100"
                    />
                </b-col>
                <b-col
                        v-if="info.text"
                        :key="`footer-text-${index}`"
                        cols="12"
                        :md="info.asset ? 10 : 12"
                        class="d-flex align-items-center"
                >
                    <div
                            class="footer-line"
                            v-html="info.text"
                    />
                </b-col>
            </template>
        </b-row>
        <b-row>
            <b-col cols="12">
                <home-compare-card
                    v-if="homeCompare && isHOH"
                    id="home-compare-card"
                    class="mt-4"
                />
            </b-col>
        </b-row>
        <b-row>
            <div class="workspace-footer d-flex w-100">
                <div class="container">
                    <div class="logo d-flex">
                        <b-link
                                :href="links.termsOfUse"
                                target="_blank"
                                class="text-underline"
                        >
                            Terms of Use
                        </b-link>
                        <b-link
                                :href="links.privacyPolicy"
                                target="_blank"
                                class="text-underline"
                        >
                            Privacy Policy
                        </b-link>
                    </div>
                </div>
            </div>
        </b-row>
        <b-row class="mt-4 mb-5 mx-0">
            <img
                    class="logo mr-3"
                    :src="require(
                        '@milestoneslabs/milestones-ui-kit/src/assets/images/workspace-footer/' +
                     'equal-housing-opportunity.png'
                    )"
                    alt="EHO"
                    :width="72"
            >
            <img
                    class="logo"
                    :src="require(
                        '@milestoneslabs/milestones-ui-kit/src/assets/images/workspace-footer/' +
                     'equal-housing-lender.png'
                    )"
                    alt="EHL"
                    :width="72"
            >
        </b-row>
    </div>
</template>
<script>
    import './PropertySearchFooter.scss';
    import {mapGetters} from "vuex";
    import {store} from "../../../index";
    import {
        PROPERTY_SEARCH_MAP_DISPLAY,
        PROPERTY_SEARCH_SAVED_SEARCHES_DISPLAY
    } from "../GroupPropertySearchHeader/PropertySearchHeader/PropertySearchHeader";
    import ApiFilter from "@milestoneslabs/milestones-js-engine/src/Api/ApiFilter";
    import ShowNotificationMixin from '@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin';
    import {
        privacyPolicy,
        termsOfUse
    } from "@milestoneslabs/milestones-ui-kit/src/helpers/externalLinks";
    import axios from "axios";
    import HomeCompareCard from "./HomeCompareCard/HomeCompareCard";
    import {HOME_OWNERSHIP} from "@milestoneslabs/milestones-core-js/src/AppResources/WorkspaceTypeAppResource";

    export default {
        name: 'PropertySearchFooter',
        components: {
            HomeCompareCard
        },
        mixins: [ShowNotificationMixin],
        data() {
            return {
                links: {
                    privacyPolicy: privacyPolicy,
                    termsOfUse: termsOfUse,

                },
                isMapDisplayed: true,
                footerData: [],
            };
        },

        computed: {
            ...mapGetters({
                homeCompare: 'getPlunkHomeCompare',
                getCurrentWorkspace: 'getCurrentWorkspace',
            }),
            isHOH() {
                return this.getCurrentWorkspace.workspaceType.type === HOME_OWNERSHIP;
            },
        },

        beforeMount() {
            this.prepareData();
            this.$bus.$on(PROPERTY_SEARCH_SAVED_SEARCHES_DISPLAY, this.displaySavedSearches);
            this.$bus.$on(PROPERTY_SEARCH_MAP_DISPLAY, this.displayMap);
        },

        beforeDestroy() {
            this.$bus.$off(PROPERTY_SEARCH_SAVED_SEARCHES_DISPLAY, this.displaySavedSearches);
            this.$bus.$off(PROPERTY_SEARCH_MAP_DISPLAY, this.displayMap);
        },

        methods: {
            displaySavedSearches() {
                this.isMapDisplayed = false;
            },
            displayMap() {
                this.isMapDisplayed = true;
            },
            async prepareData() {
                let mlsComplianceResponse = null;

                try {
                    mlsComplianceResponse = await axios.post(
                        `${window.env.MILESTONES_API_HOST}/api/v1/mls/details-rules`,
                        {
                            mlsDefinitionUuid: store.getters.getCurrentWorkspace?.mls?.uuid,
                            workspaceUuid: store.getters.getCurrentWorkspace?.uuid,
                        },
                    );
                } catch (e) {
                    this.showNotification({
                        type: 'error',
                        message: 'There was an error. Please try again later!!!!'
                    });
                }

                if (!mlsComplianceResponse) {
                    return;
                }

                const mlsData = mlsComplianceResponse.data?.data;

                const listOfData = [
                    'copyright',
                    'disclaimer',
                    'eula',
                    'dmca',
                ];

                listOfData.forEach(value => {
                    if (mlsData?.page[value]) {
                        this.footerData.push({
                            text: mlsData?.page[value]?.lexicon,
                            asset: mlsData?.page[value]?.asset
                        });
                    }
                });
            },
            async fetchMLS() {
                await this.mlsAppResourceSearch.setSearchData({
                    limit: 1,
                    filter: new ApiFilter({
                        params: {
                            abbreviation: store.getters.getCurrentProjectMlsId
                        }
                    })
                });
                try {
                    await this.mlsAppResourceSearch.search();
                } catch (e) {
                    this.showNotification({
                        message: 'Something went wrong. Please try again later',
                        type: 'error'
                    });
                    console.error(e);
                }
            },
        },
    };
</script>
